var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Listado de Inquietudes")]),_c('v-spacer'),_c('TableAllInfo',{attrs:{"headers":_vm.headersVrae,"nameTitle":'Inquietudes de VRAE',"inquietudes":_vm.inquietudes,"vrae":true},on:{"send-data":_vm.receiveData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }